import React, { Fragment } from 'react';
import { useStoreState } from 'easy-peasy';
import ClientSubGallery from './ClientSubGallery';

const ClientGallery = () => {
  const currentClient = useStoreState(state => state.currentClient);
  return (
    <Fragment>
      {
        currentClient.provinces.map((province, index) => (
          <ClientSubGallery
            type={province}
            promotions={currentClient.promotions.filter(promotion => promotion.province === province)}
          />
        ))
      }
    </Fragment>
  );
};

export default ClientGallery;
